import styled from "styled-components";

export const BottomShadowContainer = styled.div`
  position: relative;
  z-index: 10;
  box-shadow: ${p => p.showShadow && '0px 15px 15px rgba(0, 0, 0, 0.12)'};
`;